import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../Layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import showAlert from '../../../components/common/showAlert';
import ProgramModal from './ProgramModal';
import ExerciseModal from './ExerciseModal';
import CategoryModal from './CategoryModal';
import {
  fetchTrainingPrograms,
  clearMessages as clearProgramMessages,
} from '../../../redux/slices/admin/trainingSlice';
import {
  fetchExercises,
  clearMessages as clearExerciseMessages,
} from '../../../redux/slices/admin/exerciseSlice';
import {
  fetchExerciseCategories,
  clearMessages as clearCategoryMessages,
} from '../../../redux/slices/admin/exerciseCategorySlice';
import { exportClients } from '../../../redux/slices/admin/clientsSlice';
import ProgramsTable from './ProgramsTable';
import ExercisesTable from './ExercisesTable';
import CategoriesTable from './CategoriesTable';
import iconPlus from '../../../images/icon-plus-symbol.svg';
import SearchField from '../../../components/common/SearchField';
import iconPrinter from '../../../images/icon-printer.svg';
import iconDownload from '../../../images/icon-download.svg';

const Trainings = () => {
  const [activeTab, setActiveTab] = useState('programs');
  const [isProgramModalOpen, setIsProgramModalOpen] = useState(false);
  const [isExerciseModalOpen, setIsExerciseModalOpen] = useState(false);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [userType, setUserType] = useState('Both');
  const dispatch = useDispatch();

  const handleUserTypeChange = (user_type) => {
    setUserType(user_type);
    dispatch(fetchTrainingPrograms({ page: 1, searchTerm:'', userType:user_type}));
  }

  useEffect(() => {
    dispatch(fetchTrainingPrograms(1));
    dispatch(fetchExercises(1));
    dispatch(fetchExerciseCategories(1));
  }, [dispatch]);

  const successMessage = useSelector(state => {
    switch (activeTab) {
        case 'programs': 
            return state.trainingPrograms?.successMessage;
        case 'exercises':
            return state.exercises?.successMessage;
        case 'categories':
            return state.exerciseCategories?.successMessage;
        default:
            return 'none';
    }
  });

   useEffect(() => {
    if (successMessage && successMessage != '') {
      showAlert('success', successMessage);
      switch (activeTab) {
        case 'programs':
            setIsProgramModalOpen(false); dispatch(clearProgramMessages());
        case 'exercises':
            setIsExerciseModalOpen(false); dispatch(clearExerciseMessages());
        case 'categories':
            setIsCategoryModalOpen(false); dispatch(clearCategoryMessages());
        default:            
      }
    }
  }, [successMessage]);

  const handleTabChange = (tab) => {
    var search_field_value = document.getElementById('searchField').value;
    if (search_field_value.length>0) {
      if (activeTab == 'programs') {
        dispatch(fetchTrainingPrograms(1));
      }
      if (activeTab == 'exercises') {
        dispatch(fetchExercises(1));
      }
      if (activeTab == 'categories') {
        dispatch(fetchExerciseCategories(1));
      }
    }
    setActiveTab(tab);
    closeModal();
  };

  const closeModal = () => {
    setIsProgramModalOpen(false);
    setIsExerciseModalOpen(false);
    setIsCategoryModalOpen(false);
    setIsEditMode(false);
    setFormData({
      name: '',
      description: '',
    });

    dispatch(clearProgramMessages());
    dispatch(clearExerciseMessages());
    dispatch(clearCategoryMessages());
  };

  const openCreateModal = (type) => {
    switch (type) {
      case 'program':
        setIsProgramModalOpen(true);
        break;
      case 'exercise':
        setIsExerciseModalOpen(true);
        break;
      case 'category':
        setIsCategoryModalOpen(true);
        break;
      default:
        break;
    }
    setIsEditMode(false);
    setFormData({
      name: '',
      description: '',
    });
  };

  const openEditModal = (item, type) => {
    setFormData(item);
    setIsEditMode(true);
    switch (type) {
      case 'program':
        setIsProgramModalOpen(true);
        break;
      case 'exercise':
        setIsExerciseModalOpen(true);
        break;
      case 'category':
        setIsCategoryModalOpen(true);
        break;
      default:
        break;
    }
  }; 

  const handleSearch = (searchTerm, activeTab) => {
    if (activeTab == 'exercises') {
      dispatch(fetchExercises({ page: 1, searchTerm:searchTerm }));
    }
    if (activeTab == 'programs') {
      dispatch(fetchTrainingPrograms({ page: 1, searchTerm:searchTerm }));
    }
    if (activeTab == 'categories') {
      dispatch(fetchExerciseCategories({page:1, searchTerm:searchTerm}));
    }
  }


  
  const handlePageChangeFunc = (page, activeTab) => {
    var searchField = document.getElementById('searchField').value;

    if (activeTab == 'exercises') {
      dispatch(fetchExercises({ page: page, searchTerm:searchField }));
    }
    if (activeTab == 'programs') {
      dispatch(fetchTrainingPrograms({ page: page, searchTerm:searchField }));
    }
    if (activeTab == 'categories') {
      dispatch(fetchExerciseCategories({page:page, searchTerm:searchField}));
    }
  }



  const handlePrint = () => { window.print(); }

  const handleDownloadExcel = (type) => {
    dispatch(exportClients(type));
  };

  return (
    <Layout>
      <div className="container-xxl">
        <div className="row mx-0 p-3 g-3 p-md-4 nav-users-tab">
          <div className="col-md-12">
            <h1 className="title-page">Training</h1>
          </div>

          <div className="col">
            <ul className="nav nav-pills">
              <li className="nav-item">
                <a 
                  className={`nav-link ${activeTab === 'programs' ? 'active' : ''}`} 
                  onClick={() => handleTabChange('programs')}
                >
                  Programs
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className={`nav-link ${activeTab === 'exercises' ? 'active' : ''}`} 
                  onClick={() => handleTabChange('exercises')}
                >
                  Exercises
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className={`nav-link ${activeTab === 'categories' ? 'active' : ''}`} 
                  onClick={() => handleTabChange('categories')}
                >
                  Categories
                </a>
              </li>
            </ul>
          </div>

          <div className="col-12 mt-4">
            <div className="tab-content" id="pills-tabContent">
              {activeTab === 'programs' && (
                <div className="tab-pane active">
                  <ul className="ul-btns-action aa">
                  <li>
                    <a>
                      <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                    </a>
                  </li>
                  <li>
                    <a onClick={()=>handleDownloadExcel('training_programs')}>
                      <img src={iconDownload} alt="Download" />
                    </a>
                  </li>
                    <li>
                      <a onClick={() => openCreateModal('program')} className="add-plus-icon">
                        <img src={iconPlus} alt="Add Program" />
                      </a>
                    </li>
                  </ul>
                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Programs..." id="search_programs_field" />

                  {/* Select Box for User Type */}
                  <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <select
                      name="user_type"
                      id="user_type"
                      className="form-select"
                      onChange={(e) => handleUserTypeChange(e.target.value)} // define this handler
                    >
                      <option value="Both">All</option>
                      <option value="1-1 Premium">1-1 Premium</option>
                      <option value="Academy Client">Academy Client</option>
                    </select>
                  </div>

                  <ProgramsTable onEdit={(item) => openEditModal(item, 'program')} handlePageChange={(page) => handlePageChangeFunc(page, 'programs')} />
                </div>
              )}

              {activeTab === 'exercises' && (
                <div className="tab-pane active">
                  <ul className="ul-btns-action bb">
                    <li>
                    <a>
                      <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                    </a>
                  </li>
                  <li>
                    <a onClick={()=>handleDownloadExcel('exercises')}>
                      <img src={iconDownload} alt="Download" />
                    </a>
                  </li>

                    <li>
                      <a onClick={() => openCreateModal('exercise')} className="add-plus-icon">
                        <img src={iconPlus} alt="Add Exercise" />
                      </a>
                    </li>
                  </ul>
                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Exercises..." id="search_exercises_field" />
                  <ExercisesTable onEdit={(item) => openEditModal(item, 'exercise')}  handlePageChange={(page) => handlePageChangeFunc(page, 'exercises')} />
                </div>
              )}

              {activeTab === 'categories' && (
                <div className="tab-pane active">
                  <ul className="ul-btns-action cc">

                    <li>
                    <a>
                      <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                    </a>
                  </li>
                  <li>
                    <a onClick={()=>handleDownloadExcel('training_categories')}>
                      <img src={iconDownload} alt="Download" />
                    </a>
                  </li>

                    <li>
                      <a onClick={() => openCreateModal('category')} className="add-plus-icon">
                        <img src={iconPlus} alt="Add Category" />
                      </a>
                    </li>
                  </ul>
                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Categories..."  id="search_categories_field" />
                  <CategoriesTable onEdit={(item) => openEditModal(item, 'category')} handlePageChange={(page) => handlePageChangeFunc(page, 'categories')} />
                </div>
              )}
            </div>
          </div>
        </div>

        {isProgramModalOpen && (
          <ProgramModal 
            isOpen={isProgramModalOpen} 
            closeModal={closeModal} 
            initialData={formData} 
            isEditMode={isEditMode} 
          />
        )}

        {isExerciseModalOpen && (
          <ExerciseModal 
            isOpen={isExerciseModalOpen} 
            closeModal={closeModal} 
            initialData={formData} 
            isEditMode={isEditMode} 
          />
        )}

        {isCategoryModalOpen && (
          <CategoryModal 
            isOpen={isCategoryModalOpen} 
            closeModal={closeModal} 
            initialData={formData} 
            isEditMode={isEditMode} 
          />
        )}
      
      </div>
    </Layout>
  );
};

export default Trainings;